import React from "react";
import SectionHeader from "./SectionHeader";

const testimonials = [
  {
    quote:
      "John brings that rare mix of deep technical expertise and genuine empathy for the end user—a combo that makes him not just a great engineer, but a true product partner.",
    name: "Ross Piper",
    position: "Product Manager, Levi Strauss & Co.",
  },
  {
    quote:
      "John was always willing and eager to go beyond his defined role for the betterment of the system and the organization, whether that meant documenting processes, writing unique scripts, or teaching cross-functional partners about best practices.",
    name: "Ryan Keel",
    position: "UX, Levi Strauss & Co.",
  },
];

export default function TestimonialsSection() {
  const [hovered, setHovered] = React.useState(false);
  const [hoveredCard, setHoveredCard] = React.useState<number | null>(null);
  return (
    <section
      style={{
        maxWidth: 1100,
        margin: "4rem auto 0 auto",
        padding: "0 1rem 3rem 1rem",
        background: hovered ? "#f3f6fa" : "#fff",
        borderRadius: 18,
        boxShadow: "0 2px 12px rgba(37,99,235,0.06)",
        transition: "background 0.22s cubic-bezier(.4,2,.6,1)",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <SectionHeader title="Client Testimonials" />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: "2.5rem",
        }}
      >
        {testimonials.map((t, i) => (
          <div
            key={i}
            style={{
              background: "#f9fafb",
              borderRadius: 18,
              boxShadow: "0 2px 12px rgba(37,99,235,0.06)",
              padding: "2.2rem 2rem 1.5rem 2rem",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              minHeight: 180,
              transition:
                "background 0.22s cubic-bezier(.4,2,.6,1), transform 0.22s cubic-bezier(.4,2,.6,1)",
              transform: hoveredCard === i ? "scale(1.04)" : "scale(1)",
            }}
            onMouseEnter={() => setHoveredCard(i)}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "0.7rem",
                width: "100%",
                marginBottom: "1.5rem",
                transition: "transform 0.22s cubic-bezier(.4,2,.6,1)",
                transform: hoveredCard === i ? "scale(1.06)" : "scale(1)",
              }}
            >
              <span
                style={{
                  color: "#2563eb",
                  fontSize: "2.5rem",
                  fontWeight: 700,
                  lineHeight: 1,
                  fontFamily: "serif",
                  marginTop: "-0.5rem",
                  userSelect: "none",
                }}
                aria-hidden="true"
              >
                "
              </span>
              <span
                style={{
                  fontSize: "1.25rem",
                  color: "#18181b",
                  fontWeight: 500,
                  fontStyle: "italic",
                  lineHeight: 1.7,
                  fontFamily: "Georgia, Times, serif",
                  background: "rgba(37,99,235,0.04)",
                  borderLeft: "4px solid #2563eb",
                  padding: "0.5rem 1rem",
                  borderRadius: "0 12px 12px 0",
                  boxShadow: "0 1px 4px rgba(37,99,235,0.04)",
                  flex: 1,
                  display: "block",
                }}
              >
                {t.quote}
                <span
                  style={{
                    color: "#2563eb",
                    fontSize: "2.5rem",
                    fontWeight: 700,
                    lineHeight: 1,
                    fontFamily: "serif",
                    marginLeft: "0.2rem",
                    userSelect: "none",
                  }}
                  aria-hidden="true"
                >
                  "
                </span>
              </span>
            </div>
            <div
              style={{
                color: "#6b7280",
                fontWeight: 600,
                fontSize: "1rem",
                marginBottom: 2,
              }}
            >
              {t.name}
            </div>
            <div
              style={{
                color: "#9ca3af",
                fontWeight: 500,
                fontSize: "0.98rem",
                marginBottom: "0.5rem",
              }}
            >
              {t.position}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
